import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import translationAR from './locales/ar/translation.json';
import translationEN from './locales/en/translation.json';

// Get saved language from localStorage or default to Arabic
const getSavedLanguage = () => {
  const savedLang = localStorage.getItem('mahsool_language');
  // Only return saved language if it's 'en', otherwise default to 'ar'
  return savedLang === 'en' ? 'en' : 'ar';
};

// Initialize i18n
i18n
  .use(initReactI18next)
  .init({
    resources: {
      ar: {
        translation: translationAR
      },
      en: {
        translation: translationEN
      }
    },
    lng: getSavedLanguage(), // Get language from our custom function
    fallbackLng: 'ar', // Always fallback to Arabic
    interpolation: {
      escapeValue: false // React already safe from XSS
    }
  });

// Helper function to change and save language
export const changeLanguage = (lng) => {
  i18n.changeLanguage(lng);
  localStorage.setItem('mahsool_language', lng);
  
  // Update HTML direction
  document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.lang = lng;
  
  // Update ToastContainer direction
  const toastContainer = document.querySelector('.Toastify__toast-container');
  if (toastContainer) {
    toastContainer.setAttribute('dir', lng === 'ar' ? 'rtl' : 'ltr');
  }
};

export default i18n;